<template>
  <div class="content-panel">
    <a-input-search
      v-model="dimName"
      style="margin-bottom: 8px"
      placeholder="请选择资产类型"
      @search="queryDictData"
      @pressEnter="queryDictData"
    />
    <a-spin :spinning="loading" wrapperClassName="spin" class="leftBottomTree">
      <a-card :bordered="false">
        <a-tree
          style="height:100%"
          v-if="treeData.length > 0"
          :expandedKeys="defaultSelectedKeys"
          :selectedKeys="selectedKeys"
          :treeData="seatchTreeData"
          :draggable="false"
          @expand="onExpand"
          @select="select"
        >
          <template slot="custom" slot-scope="item">
            <span class="treeCompanyName">{{ item.name }}</span>
          </template>
        </a-tree>
      </a-card>
    </a-spin>
    <ul v-show="visible" :style="{left:left+'px',top:top+'px'}" class="contextmenu">
      <li @click="derive()">导出当前台账</li>
    </ul>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { getAssetTypeTreeList, getDeptTreeList } from '@/api/assetLedger'
export default {
  name: 'OrgTree',
  data () {
    return {
      expandedKeys: [],
      loading: false,
      dimName: '',
      treeData: [],
      seatchTreeData: [],
      defaultSelectedKeys: ['000000'],
      selectedKeys: ['000000'],
      visible: false,
      top: 0,
      left: 0,
      numberOfUpdates: 0
    }
  },
  created () {
    // 获取资产类型
    this.getAssetType()
  },
  mounted () {
    this.$nextTick(() => {
      const dom = document.getElementsByClassName('leftBottomTree')[0]
      dom.oncontextmenu = this.openContextmenu
    })
  },
  watch: {
    visible (value) {
      if (value) {
        document.body.addEventListener('click', this.closeMenu)
      } else {
        document.body.removeEventListener('click', this.closeMenu)
      }
    }
  },
  methods: {
    ...mapActions(['handleAssetAnlkl', 'handleAssetAnlklArr']),
    onExpand (expandedKeys) {
      this.defaultSelectedKeys = expandedKeys
    },
    // 关闭右键菜单
    closeMenu () {
      console.log('btn')
      this.visible = false
    },
    openContextmenu (e) {
      console.log(this.visible)
      e.preventDefault()
      e.stopPropagation()
      this.$emit('closeMenu', 'leftBottom')
      this.top = e.pageY - 41
      this.left = e.pageX
      this.visible = true
    },
    // 导出
    derive () {
      this.$emit('derive')
    },
    // 在树数组中找到对应id的数据,并返回数据对象
    findData (arr, code, typeCode = false) {
      let data = null
      if (arr && arr.length > 0) {
        for (let i = 0; i < arr.length; i++) {
          const item = arr[i]
          if (typeCode) {
            if (item.typeCode === code) {
              data = item
              break
            } else {
              if (item.children && item.children.length > 0) {
                data = this.findData(item.children, code, typeCode)
                if (data) {
                  break
                }
              }
            }
          } else if (item.code === code) {
            data = item
            break
          } else {
            if (item.children && item.children.length > 0) {
              data = this.findData(item.children, code)
              if (data) {
                break
              }
            }
          }
        }
      }
      return data
    },
    // 获取给定数组下的所有子数组的id，返回一个id数组
    getChildrenDeptId (arr) {
      let idArr = []
      if (arr && arr.length > 0) {
        for (let i = 0; i < arr.length; i++) {
          const item = arr[i]
          // 如果有code才添加
          if (item.code) {
            idArr.push(item.code)
          }
          if (item.children && item.children.length > 0) {
            idArr = idArr.concat(this.getChildrenDeptId(item.children))
          }
        }
      }
      return idArr
    },
    formateData (arr) {
      const list = []
      const self = this
      if (arr && arr.length > 0) {
        for (let i = 0; i < arr.length; i++) {
          const item = JSON.parse(JSON.stringify(arr[i]))
          item.key = item.code
          item.scopedSlots = { title: 'custom' }
          if (item.children && item.children.length) {
            item.children = self.formateData(item.children)
          }
          list.push(item)
        }
      }
      return list
    },
    // 获取资产类型
    async getAssetType () {
      const data = {
        pCode: 'zcfl',
        dimName: this.dimName
      }
      this.loading = true
      getAssetTypeTreeList().then(res => {
        if (res.status === 0) {
          if (res.data.length > 0) {
            res.data.map(item => {
              item.id = item.typeCode
              item.key = item.typeCode
              item.scopedSlots = { title: 'custom' }
              item.children = this.formateData(item.children, item.id)
              item.parent = true
            })
            this.treeData = JSON.parse(JSON.stringify(res.data))
            this.seatchTreeData = [
              {
                id: '资产分类',
                key: '资产分类',
                scopedSlots: { title: 'custom' },
                name: '资产',
                code: '资产分类',
                parent: true,
                children: JSON.parse(JSON.stringify(res.data))
              }
            ]
            const data = this.seatchTreeData[0]
            this.defaultSelectedKeys = data.typeCode ? [data.typeCode] : [data.code]
            this.selectedKeys = data.typeCode ? [data.typeCode] : [data.code]
          } else {
            this.treeData = []
            this.defaultSelectedKeys = []
            this.selectedKeys = []
          }
          const data = this.seatchTreeData[0]
          this.handleAssetAnlkl({
            anlkl: this.treeData.length > 0 ? (data.typeCode ? data.typeCode : data.code) : '空',
            anlklCodeList: this.treeData.length > 0 ? (data.typeCode ? data.codeList : [data.code]) : '空',
            type: data.typeCode ? 'parent' : 'child',
            numberOfUpdates: this.numberOfUpdates++
          })
          this.handleAssetAnlklArr({
            anlkl: this.getChildrenDeptId(data.children),
            checkAll: true,
            numberOfUpdates: this.numberOfUpdates++
          })
          this.loading = false
        } else {
          this.$message.error(res.info.message)
          this.loading = false
        }
      })
    },
    // 调用父组件的获取使用部门数据方法
    select (data, info) {
      if (data.length > 0) {
        this.selectedKeys = data
        let codeData = ''
        let codeList = []
        let typeCode = null
        console.log(info.selectedNodes[0].data.props)
        if (info.selectedNodes.length === 1) {
          codeData = info.selectedNodes[0].data.props.typeCode ? info.selectedNodes[0].data.props.typeCode : info.selectedNodes[0].data.props.code
          codeList = info.selectedNodes[0].data.props.typeCode ? info.selectedNodes[0].data.props.codeList : [info.selectedNodes[0].data.props.code]
          typeCode = !!info.selectedNodes[0].data.props.typeCode
        }
        this.handleAssetAnlkl({
          anlkl: codeData,
          anlklCodeList: codeList,
          type: info.selectedNodes[0].data.props.typeCode ? 'parent' : 'child',
          numberOfUpdates: this.numberOfUpdates++
        })
        if (codeData === '资产分类') {
          this.handleAssetAnlklArr({
            anlkl: this.getChildrenDeptId(this.treeData[0].children),
            checkAll: true,
            numberOfUpdates: this.numberOfUpdates++
          })
        } else {
          this.handleAssetAnlklArr({
            anlkl: this.getChildrenDeptId([this.findData(this.treeData, codeData, typeCode)]),
            numberOfUpdates: this.numberOfUpdates++
          })
        }
      }
    },
    // 搜索设备分类
    queryDictData () {
      const results = []
      function fuzzySearch (str, obj) {
        for (var i = 0; i < obj.length; i++) {
          if (obj[i].typeCode) {
            if (obj[i].name.indexOf(str) !== -1) {
              const chilren = []
              for (let j = 0; j < obj[i].children.length; j++) {
                const item = obj[i].children[j]
                if (item.name.indexOf(str) !== -1) {
                  chilren.push(item)
                }
              }
              obj[i].children = chilren
              results.push(obj[i])
            }
          } else {
            if (obj[i].name.indexOf(str) !== -1) {
              let bool = false
              for (let j = 0; j < results.length; j++) {
                const item = results[j]
                if (item.children) {
                  for (let k = 0; k < item.children.length; k++) {
                    const child = item.children[k]
                    if (child.name.indexOf(str) !== -1) {
                      if (child.name === obj[i].name) {
                        bool = true
                      }
                    }
                  }
                }
              }
              if (!bool) {
                results.push(obj[i])
              }
            }
          }
          if (obj[i].children) {
            fuzzySearch(str, obj[i].children)
          }
        }
        return results
      }
      if (this.dimName) {
        // 如果有搜索条件
        this.seatchTreeData = fuzzySearch(this.dimName, JSON.parse(JSON.stringify(this.treeData)))
      } else {
        // 如果没有搜索条件
        this.seatchTreeData = [
          {
            id: '资产分类',
            key: '资产分类',
            scopedSlots: { title: 'custom' },
            name: '资产',
            code: '资产分类',
            parent: true,
            children: JSON.parse(JSON.stringify(this.treeData))
          }
        ]
      }
      const data = this.seatchTreeData[0]
      if (this.seatchTreeData.length > 0) {
        let codeData = null
        let typeCode = null
        this.defaultSelectedKeys = data.typeCode ? [data.typeCode] : [data.code]
        this.selectedKeys = data.typeCode ? [data.typeCode] : [data.code]
        codeData = data.typeCode ? data.typeCode : data.code
        typeCode = !!data.typeCode
        this.handleAssetAnlkl({
          anlkl: this.seatchTreeData.length > 0 ? (data.typeCode ? data.typeCode : data.code) : '空',
          anlklCodeList: this.seatchTreeData.length > 0 ? (data.typeCode ? data.codeList : [data.code]) : [],
          type: data.typeCode ? 'parent' : 'child',
          numberOfUpdates: this.numberOfUpdates++
        })
        if (codeData === '资产分类') {
          this.handleAssetAnlklArr({
            anlkl: this.getChildrenDeptId(data.children),
            checkAll: true,
            numberOfUpdates: this.numberOfUpdates++
          })
        } else {
          this.handleAssetAnlklArr({
            anlkl: this.getChildrenDeptId([this.findData(this.seatchTreeData, codeData, typeCode)]),
            numberOfUpdates: this.numberOfUpdates++
          })
        }
      } else {
        this.defaultSelectedKeys = []
        this.selectedKeys = []
        this.handleAssetAnlkl({
          anlkl: this.seatchTreeData.length > 0 ? (data.typeCode ? data.typeCode : data.code) : '空',
          anlklCodeList: this.seatchTreeData.length > 0 ? (data.typeCode ? data.codeList : [data.code]) : [],
          numberOfUpdates: this.numberOfUpdates++
        })
        this.handleAssetAnlklArr({
          anlkl: '空',
          numberOfUpdates: this.numberOfUpdates++
        })
      }
      this.$forceUpdate()
    }
  }
}
</script>
<style lang="less">
.ant-modal-body {
  #chart-container {
    overflow-x: auto;
  }
}

.ant-tooltip {
  z-index: 1020;
}
.content-panel {
  height: 100%;
  //padding-bottom: 20px;
  .action-btn-line {
    display: flex;
    justify-content: space-between;
  }

  .ant-tree-title {
    width: 100%;

    & > span {
      // width: 90px;
      display: inline-block;
      white-space: pre-line !important;
    }
  }
  .title {
    float: left;
  }

  .ant-card-body {
    padding: 0;

    :global {
      .ant-tree {
        line-height: 3;

        .ant-tree-node-content-wrapper,
        .ant-tree-switcher {
          height: auto;
          margin-top: 5px;
          margin-bottom: 5px;
        }
        .ant-tree-node-content-wrapper:hover {
          background: transparent;
        }
        .ant-tree-treenode-selected {
          background: #e6f7ff;
          height: auto !important;
          .ant-tree-node-selected {
            background: transparent;
          }
        }

        .ant-tree-child-tree {
          background: #fff;
        }
        li {
          position: relative;
          line-height: 3;
          padding-bottom: 0;
        }
      }
      .ant-btn {
        margin-bottom: 8px;
      }
    }

    .icon-panel {

      .anticon-plus,
      .anticon-setting,
      .anticon-edit,
      .anticon-delete {
        margin-left: 5px;
        color: #1890ff;
      }
    }
  }
}
/deep/.ant-tree-treenode-switcher-close  {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 0 4px 0 !important;
  height: auto;
  margin: 0 !important;
}
/deep/.ant-tree-node-content-wrapper-close {
  height: auto;
}
/deep/.ant-tree-treenode-switcher-open {
  padding: 0 !important;
}
/deep/.ant-tree-node-content-wrapper-open {
  margin: 0 !important;
  height: auto;
}
/deep/.ant-tree-node-content-wrapper {
  margin: 0 !important;
  height: auto;
}
/deep/.ant-tree-node-selected {
  height: auto;
}
.content-panel .ant-tree li {
  margin: 0!important;
  padding: 0!important;
  height: auto;
}
.content-panel .ant-tree li .ant-tree-child-tree {
  margin: 0!important;
}
/deep/.ant-tree li {
  margin: 0!important;
  padding: 0!important;
}
.spin {
  height: calc(100% - 40px);
  overflow: auto;
}
.treeCompanyName {
  font-size: 14px;
}
.contextmenu {
  margin: 0;
  background: #fff;
  z-index: 3000;
  position: absolute;
  list-style-type: none;
  padding: 5px 4px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 400;
  color: #333;
  box-shadow: 3px 3px 8px 0 rgba(0, 0, 0, 0.3);
  width: 120px;
  text-align: center;
}

.contextmenu li {
  margin: 0;
  padding: 7px 16px;
  cursor: pointer;
}

.contextmenu li:hover {
  background: rgba(231, 244, 255, 1);
}
</style>
